<template>
  <div class="basicCover">
    <Locale />
    <div class="imgBox">
      <q-img basic :src="storeInfo.cover || defaultCover" :ratio="9 / 7" />
      <q-img basic :src="storeInfo.logo || defaultLogo" class="logoImg" />
    </div>
    <div class="store-name">{{ storeInfo.name }}</div>
    <div class="q-px-lg">
      <Button :status="info.status" />
    </div>
    <Bottom />
  </div>
</template>

<script>
import { defaultCover, defaultLogo } from 'src/utils/config';
import { Locale, Button, Bottom } from '../../components/index';

export default {
  name: 'BasicCover',
  components: { Locale, Button, Bottom },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultLogo,
      defaultCover,
    };
  },
};
</script>
<style lang="scss" scoped>
.imgBox {
  position: relative;
  .logoImg {
    width: 160px;
    height: 160px;
    position: absolute;
    left: 50%;
    border: 4px solid #ffffff;
    border-radius: 50%;
    transform: translate(-50%, 50%);
    bottom: 0;
    z-index: 10;
  }
}
.store-name {
  max-width: 312px;
  font-weight: 700;
  font-size: 36px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.05em;
  color: $black;
  margin: 94px auto 40px;
}
.q-btn {
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
}
</style>
